(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9465],{

/***/ 79465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12147);
/* harmony import */ var _styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40607);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70710);
/* harmony import */ var _lib_layout_snapshot_json__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31868);
















const snapshot = _lib_layout_snapshot_json__WEBPACK_IMPORTED_MODULE_9__;
const KcNewLatestUpdates = (incomingProps)=>{
    const props = {
        ...incomingProps,
        footerData: incomingProps?.footerData ?? snapshot.footerData
    };
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: news , 1: setNews  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const settings = {
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        cssEase: "linear",
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false
    };
    const desktopSettings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        autoplaySpeed: 2000,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            }, 
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/blogs?stu_dest_categories.category=News&_sort=date:DESC`, "GET", {}, "", false).then((res)=>{
            setNews(res);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        id: "kcupdates-main-div",
        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().kcupdatesMainDiv),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-center",
                            children: "Latest KC Updates"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "d-none d-sm-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "kcupdates-div",
                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().kcupdatesDiv),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    lg: 5,
                                    md: 4,
                                    sm: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        className: `${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card)} ${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().weHireCard)}`,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Body */ .Z.Body, {
                                            className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cardBody),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Title */ .Z.Title, {
                                                    className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                                    children: props.footerData?.hiringTitle
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Text */ .Z.Text, {
                                                    className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().text),
                                                    children: props.footerData?.hiringDescription
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: props.footerData?.hiringButtonLink,
                                                    className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().navLink),
                                                    "aria-label": props.footerData?.hiringButtonLabel,
                                                    children: props.footerData?.hiringButtonLabel
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    lg: 7,
                                    md: 8,
                                    sm: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            ...desktopSettings,
                                            children: news.length > 0 && news.map((data, index)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    lg: 6,
                                                    md: 6,
                                                    sm: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: data?.isExternalLink && data?.externalLink ? data?.externalLink : `/news/${data.slug}`,
                                                            "aria-label": "Read more",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                className: `${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card)} ${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().certificate)}`,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Body */ .Z.Body, {
                                                                    className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cardBody),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_7__.LazyLoadComponent, {
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().img),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Img */ .Z.Img, {
                                                                                    height: 120,
                                                                                    width: 120,
                                                                                    variant: "top",
                                                                                    alt: data?.newCardImageUrl?.alt,
                                                                                    src: data?.newCardImageUrl?.imageUrl || "/recognitions/airc.svg"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleClass),
                                                                            children: data?.title
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().description),
                                                                            children: data?.shortDescription
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().star),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                                                src: "/recognitions/stars.svg",
                                                                                alt: "multi-country.svg",
                                                                                width: 70,
                                                                                height: 20
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().readMore),
                                                                            href: data?.isExternalLink && data?.externalLink ? data?.externalLink : `/news/${data.slug}`,
                                                                            "aria-label": "Read more",
                                                                            children: "Read More"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                }, index);
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "d-block d-sm-none",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "kcupdates-divs",
                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().kcupdatesDiv),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...settings,
                                ref: sliderRef,
                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().slider),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            className: `${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card)} ${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().weHireCard)}`,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Body */ .Z.Body, {
                                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cardBody),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Title */ .Z.Title, {
                                                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                                        children: props.footerData?.hiringTitle
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Text */ .Z.Text, {
                                                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().text),
                                                        children: props.footerData?.hiringDescription
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: props.footerData?.hiringButtonLink,
                                                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().navLink),
                                                        children: props.footerData?.hiringButtonLabel
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    news.length > 0 && news.map((data, index)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: data?.isExternalLink && data?.externalLink ? data?.externalLink : `/news/${data.slug}`,
                                                "aria-label": `Read more about ${data.title}`,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    className: `${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card)} ${(_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().certificate)}`,
                                                    onClick: ()=>next_router__WEBPACK_IMPORTED_MODULE_6___default().push(`/news/${data.slug}`),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Body */ .Z.Body, {
                                                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cardBody),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_7__.LazyLoadComponent, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().img),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Img */ .Z.Img, {
                                                                        variant: "top",
                                                                        src: data?.cardImageUrl || "/recognitions/airc.svg"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleClass),
                                                                children: data?.title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().description),
                                                                children: data?.shortDescription
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().star),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                                    src: "/recognitions/stars.svg",
                                                                    alt: "multi-country.svg",
                                                                    width: 70,
                                                                    height: 20
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().readMore),
                                                                href: `/news/${data.slug}`,
                                                                "aria-label": `Read more about ${data.title}`,
                                                                children: "Read More"
                                                            })
                                                        ]
                                                    })
                                                }, index)
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "arrowleft"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "arrowright"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 mb-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            id: "kcupdate-news",
                            href: "/news",
                            className: (_styles_kclatestupdates_module_scss__WEBPACK_IMPORTED_MODULE_11___default().viewMore),
                            children: "More News"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (KcNewLatestUpdates);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 12147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"kcupdatesMainDiv":"kclatestupdates_kcupdatesMainDiv__84tEh","sliderDots":"kclatestupdates_sliderDots__3cIwV","card":"kclatestupdates_card__107XM","cardBody":"kclatestupdates_cardBody__jpfjQ","img":"kclatestupdates_img__0FlV5","kcNews":"kclatestupdates_kcNews__UQOZg","newsImages":"kclatestupdates_newsImages__IPzZF","newsimg":"kclatestupdates_newsimg__ikhaD","weHireCard":"kclatestupdates_weHireCard__5D9K6","title":"kclatestupdates_title__4p3y1","text":"kclatestupdates_text__mhLzB","certificate":"kclatestupdates_certificate__0AqTm","star":"kclatestupdates_star__DHzoE","viewMore":"kclatestupdates_viewMore__4gcP0","description":"kclatestupdates_description__240WZ","titleClass":"kclatestupdates_titleClass__N_MW7","arrowsClass":"kclatestupdates_arrowsClass__Jbkag","btcircle":"kclatestupdates_btcircle__VmMYR"};

/***/ })

}]);